import { render, staticRenderFns } from "./select_product_componentization.vue?vue&type=template&id=15ab1564&scoped=true"
import script from "./select_product_componentization.vue?vue&type=script&lang=js"
export * from "./select_product_componentization.vue?vue&type=script&lang=js"
import style0 from "./select_product_componentization.vue?vue&type=style&index=0&id=15ab1564&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ab1564",
  null
  
)

export default component.exports